export default () => ({
    swiper: null,
    init() {
        this.enable();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.heroCarousel, {
            slidesPerView: 1,
            loop: true,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                bulletClass: 'c-swiper-pagination-bullet',
                bulletActiveClass: 'c-swiper-pagination-bullet-active'
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                speed: 2000
            }
        });
    }
});
